<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      md="12"
      class="py-0"
    >
      <v-radio-group
        v-model="value.w9.uploadPDF"
        row
      >
        <v-radio
          label="Generate W9"
          color="primary"
          :value="false"
          data-cy="submission-w9-radio-generate"
        />
        <v-radio
          label="Upload W9"
          color="primary"
          :value="true"
          data-cy="submission-w9-radio-upload"
        />
      </v-radio-group>
    </v-col>

    <v-col
      v-if="!value.w9.uploadPDF"
      cols="12"
    >
      <v-row>
        <v-col
          cols="6"
          class="py-0"
        >
          {{ value.employee.loanOut }}
        </v-col>

        <v-col
          cols="12"
          class="py-0"
        >
          <v-select
            data-cy="submission-w9-select-tax-classification"
            :value="value.w9.taxClassification"
            label="Federal Tax Classification*"
            :items="w9TaxClassifications"
            :rules="[rules.required]"
            @input="(val) => {
              $emit('input',{
                ...value,
                w9 : {
                  ...value.w9,
                  taxClassification: val
                }
              })
            }"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col
      v-if="value.w9.uploadPDF"
      cols="12"
    >
      <file-uploader
        :value="w9Upload"
        @input="(val) => {
          $emit('input-w9-upload', val)
        }"
      />
    </v-col>

    <v-col
      cols="12"
      class="pt-4"
    >
      <h3> Article of Incorporation </h3>
    </v-col>
    <v-col
      cols="12"
    >
      <file-uploader
        :value="articleOfIncorporationUpload"
        @input="(val) => {
          $emit('input-article-of-incorporation', val)
        }"
      />
    </v-col>
  </v-row>
</template>

<script>
import rules from '../utils/rules';
import masks from '../utils/masks';
import FileUploader from './FileUploader.vue';

export default {
  components: {
    FileUploader,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    articleOfIncorporationUpload: {
      type: String,
      default: null,
    },
    w9Upload: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      w9TaxClassifications: [
        {
          text: 'Individual/Sole Proprietor or Single-Member LLC',
          value: 'individualSoleProprietor',
        },
        {
          text: 'C Corporation',
          value: 'cCorporation',
        },
        {
          text: 'S Corporation',
          value: 'sCorporation',
        },
        {
          text: 'Partnership',
          value: 'partnership',
        },
        {
          text: 'Trust/Estate',
          value: 'trustEstate',
        },
      ],
      rules,
      masks,
    };
  },
};
</script>
